import React, { useCallback, useEffect, useState, createElement } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { BonusSection } from './components/BonusSection';
import { FinalCTA } from './components/FinalCTA';
import { ClosingSection } from './components/ClosingSection';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  const [addedBumps, setAddedBumps] = useState<Record<string, boolean>>({});
  useEffect(() => {
    initMetaPixel();
    // Facebook domain verification
    const meta = document.createElement('meta');
    meta.name = 'facebook-domain-verification';
    meta.content = '8wwmh40g2jwa80oar4i2jkf0awkz1c';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
  const toggleBump = useCallback((id: string) => {
    setAddedBumps(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  }, []);
  return <div className="w-full min-h-screen bg-dark-bg" data-id="element-0">
      <Header addedBumps={addedBumps} data-id="element-1" />
      <main data-id="element-2">
        <HeroSection addedBumps={addedBumps} data-id="element-3" />
        <BonusSection data-id="element-4" />
        <FinalCTA addedBumps={addedBumps} data-id="element-5" />
        <ClosingSection addedBumps={addedBumps} data-id="element-6" />
      </main>
    </div>;
}